import { getPrimeGlobalProps } from '@stores/prime-quota/selectors';
import { DST_STATES } from './utils';

const sanitized = (value, fallback = 'NA') => {
  if (value === null || value === undefined || value === '') {
    return fallback;
  }
  return String(value);
};

export default function buildScholarshipDiscountCouponEventProps({
  goalUID,
  goalName,
  lps,
  code,
  discountPercentage,
  state
}) {
  return {
    goal_uid: sanitized(goalUID),
    goal_name: sanitized(goalName),
    last_primary_source: sanitized(lps),
    last_primary_source_section: sanitized(lps, 'Home'),
    scholarship_test_state: state,
    is_reattempt: state === DST_STATES.REATTEMPT,
    is_resumed: state === DST_STATES.RESUME,
    referral_code: sanitized(code),
    discount_percentage: discountPercentage,
    ...getPrimeGlobalProps()
  };
}
